/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentCreditDto
 */
export interface NovitusPaymentCreditDto {
    /**
     * Nazwa formy płatności kredytem
     * @type {string}
     * @memberof NovitusPaymentCreditDto
     */
    name: string;
    /**
     * Wartość płatności kredytem
     * @type {string}
     * @memberof NovitusPaymentCreditDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentCreditDto interface.
 */
export function instanceOfNovitusPaymentCreditDto(value: object): value is NovitusPaymentCreditDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentCreditDtoFromJSON(json: any): NovitusPaymentCreditDto {
    return NovitusPaymentCreditDtoFromJSONTyped(json, false);
}

export function NovitusPaymentCreditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentCreditDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentCreditDtoToJSON(value?: NovitusPaymentCreditDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

